module.exports = __webpack_public_path__ + "static/media/Salir.a5a9c88b.svg";